<div class="table-section">
  <mat-expansion-panel
    [expanded]="expandPanel"
    class="mat-elevation-z0 expansion-panel w-full"
  >
    <mat-expansion-panel-header
      class="bg-black-100 expansion-panel-header justify-center"
    >
      <div class="title"> Daily Physical Activity </div>
      <div class="flex items-center">
        <app-icon
          class="add-icon"
          svgIcon="physical-activity"
        ></app-icon>
        <span class="red-light-label"
          >Total Physical Activity Points: {{ totalPa | number:'1.0':'en-US' }}</span
        >
      </div>
    </mat-expansion-panel-header>
    <div class="table-container">
      <table
        [dataSource]="dataSource"
        class="mat-elevation-z8"
        mat-table
      >
        <ng-container
          [sticky]="true"
          matColumnDef="dayTime"
        >
          <th
            *matHeaderCellDef
            class="min-w-[18rem]"
            mat-header-cell
          >
            <div class="th-cell"> Time of Day </div>
          </th>
          <td
            *matCellDef="let eachRow; let index = index"
            mat-cell
          >
            <div class="td-cell">
              <div class="daily-tracker-title text-wrapper">
                {{ eachRow.typeText }}
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="activity">
          <th
            *matHeaderCellDef
            class="min-w-[15rem]"
            mat-header-cell
          >
            <div class="th-cell daily-tracker-title"> Activity </div>
          </th>
          <td
            *matCellDef="let eachRow"
            mat-cell
          >
            <div
              class="td-cell daily-tracker-content daily-tracker-title text-wrapper"
            >
              {{ eachRow?.activity }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="intensity">
          <th
            *matHeaderCellDef
            class="min-w-[15rem]"
            mat-header-cell
          >
            <div class="th-cell daily-tracker-title"> Intensity </div>
          </th>
          <td
            *matCellDef="let eachRow"
            mat-cell
          >
            <div
              class="td-cell daily-tracker-content daily-tracker-title text-wrapper flex items-center"
            >
              {{ eachRow?.intensity }}
              <app-icon
                *ngIf="getIntensityIcon(eachRow?.intensity)"
                [svgIcon]="getIntensityIcon(eachRow?.intensity)"
                class="ml-2"
              ></app-icon>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="mins">
          <th
            *matHeaderCellDef
            class="min-w-[15rem]"
            mat-header-cell
          >
            <div class="th-cell daily-tracker-title"> Minutes </div>
          </th>
          <td
            *matCellDef="let eachRow"
            mat-cell
          >
            <div class="td-cell daily-tracker-content daily-tracker-title">
              {{ eachRow?.duration ? eachRow?.duration + " mins" : "" }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="points">
          <th
            *matHeaderCellDef
            class="min-w-[15rem]"
            mat-header-cell
          >
            <div class="th-cell daily-tracker-title">
              Physical Activity Points
            </div>
          </th>
          <td
            *matCellDef="let eachRow"
            mat-cell
          >
            <div class="td-cell daily-tracker-content daily-tracker-title">
              <app-icon
                class="add-icon"
                svgIcon="physical-activity"
              ></app-icon>
              {{ eachRow?.points | number:'1.0':'en-US' }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="comments">
          <th
            *matHeaderCellDef
            class="min-w-[15rem] max-w-[15rem]"
            mat-header-cell
          >
            <div class="th-cell daily-tracker-title"> Comments </div>
          </th>
          <td
            *matCellDef="let eachRow"
            mat-cell
            class="min-w-[15rem] max-w-[15rem]"
          >
            <div
              class="td-cell daily-tracker-content daily-tracker-title text-wrapper"
              [matTooltip]="eachRow?.comments"
              [matTooltipDisabled]="!eachRow?.comments || eachRow?.comments?.length <= 50"
              matTooltipClass="custom-tooltip"
            >
              {{ eachRow?.comments?.length > 50 ? (eachRow?.comments | slice:0:50) + '...' : eachRow?.comments }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th
            *matHeaderCellDef
            class="min-w-[5rem] w-[5rem]"
            mat-header-cell
          >
            <div class="th-cell survey-title">
              <!--Status-->
            </div>
          </th>
          <td
            *matCellDef="let eachRow"
            mat-cell
          >
            <div class="td-cell menu survey-content survey-title">
              <button
                [matMenuTriggerFor]="menu"
                mat-icon-button
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  (click)="onEditClicked(eachRow)"
                  class="duplicate-menu-button"
                  mat-menu-item
                >
                  Edit
                </button>
                <button
                  (click)="onDeleteRecord(eachRow)"
                  class="duplicate-menu-button"
                  mat-menu-item
                  >Delete
                </button>
              </mat-menu>
            </div>
          </td>
        </ng-container>
        <tr
          *matHeaderRowDef="colDef; sticky: true"
          mat-header-row
        ></tr>
        <tr
          *matRowDef="let row; columns: colDef"
          mat-row
        ></tr>
      </table>
      <div
        *ngIf="loading"
        [ngClass]="{ initial: !dataSource?.data?.length }"
        class="table-loader w-full flex justify-center items-center"
      >
        <mat-spinner />
      </div>
      <div
        *ngIf="!dataSource?.length && !loading"
        class="no-data flex flex-col justify-center items-center"
      >
        <div class="text"> No Data Found </div>
      </div>
    </div>
  </mat-expansion-panel>
</div>

<div
  *ngIf="!loading"
  class="add-new-section flex justify-center items-center"
>
  <app-icon
    (click)="addPhysicalActivity()"
    class="add-icon"
    svgIcon="add"
  ></app-icon>
  <span
    (click)="addPhysicalActivity()"
    class="add-button-label"
    >Add Activity</span
  >
</div>
